import { mittweidaFields } from 'mittweida/inquiry/fields';
import { fieldValidators } from 'modules/Inquiry/inquiryFieldValidation/customValidations';
import { ValidationMapType } from 'new/form/common/types';
import { InquiryConstants } from 'schema/inquirySchema.constants';

const {
  demolitionNecessary,
  heritageProtected,
  developmentNecessary,
  ownSalesPlanned,
  energyPass,
  buildingPermit,
  permitBasis,
  permitStatus,
  notesOnPermit,
} = mittweidaFields.financingNeedPage.otherProjectInformation;

export const otherProjectInformationSectionValidationMap: ValidationMapType = {
  [demolitionNecessary]: fieldValidators.boolean().required(),
  [heritageProtected]: fieldValidators.boolean().required(),
  [developmentNecessary]: fieldValidators.boolean().required(),
  [ownSalesPlanned]: fieldValidators.boolean().optional(),
  [energyPass]: fieldValidators.boolean().optional(),
  [buildingPermit]: fieldValidators.boolean().optional(),
  [permitBasis]: fieldValidators.string().optional(),
  [permitStatus]: fieldValidators.string().optional(),
  [notesOnPermit]: fieldValidators
    .string()
    .optional()
    .max(InquiryConstants.MAX_MITTWEIDA_NOTES_ON_PERMIT_LENGTH),
};
